import { useLocation } from 'js/lib/useRouter';

import { doesUrlPathMatchLocaleSubfolderPattern } from 'bundles/internationalization-lib/utils/subfolderPatternMatcher';

const useIsOnLocaleSubfolderRoute = () => {
  const location = useLocation();
  return doesUrlPathMatchLocaleSubfolderPattern(location.pathname);
};

export default useIsOnLocaleSubfolderRoute;
